import { SettingsEndpoint } from "@constants/ApiEndpoints";
import { AxiosInstance } from "axios";
import { BillingGroupModel } from "models/Settings/RevenuManagement/BillingGroupModel";
import { FetchingRequestParamsModels } from "models/Shared/FetchingRequestParamsModels";

export const remove =
  (axios: AxiosInstance) =>
  async (id: number): Promise<BillingGroupModel> => {
    return await axios.delete(
      `${SettingsEndpoint.SETTINGS_REVENU_MANAGEMENT_BILLING_GROUP}/${id}`
    );
  };

export const getAll =
  (axios: AxiosInstance) =>
  async (
    params?: FetchingRequestParamsModels
  ): Promise<BillingGroupModel[]> => {
    return await axios
      .get(SettingsEndpoint.SETTINGS_REVENU_MANAGEMENT_BILLING_GROUP, {
        params,
      })
      .then(({ data }) => data.items);
  };

export const create =
  (axios: AxiosInstance) =>
  async (
    data: Omit<BillingGroupModel, "charge_codes"> & { charge_codes: number[] }
  ): Promise<BillingGroupModel> => {
    return await axios
      .post(SettingsEndpoint.SETTINGS_REVENU_MANAGEMENT_BILLING_GROUP, data)
      .then(({ data }) => data);
  };

export const update =
  (axios: AxiosInstance) =>
  async (data: BillingGroupModel): Promise<BillingGroupModel> => {
    return await axios
      .put(
        `/${SettingsEndpoint.SETTINGS_REVENU_MANAGEMENT_BILLING_GROUP}/${data.id}`,
        data
      )
      .then(({ data }) => data);
  };

export const toggleStatus =
  (axios: AxiosInstance) =>
  async (id: number): Promise<BillingGroupModel> => {
    return await axios
      .patch(
        `/${SettingsEndpoint.SETTINGS_REVENU_MANAGEMENT_BILLING_GROUP}/${id}`
      )
      .then(({ data }) => data);
  };
